<template>
  <CustomTitleBar title="我的口袋" right-text="账单" icon-color="#fff" title-color="#fff" right-text-color="#fff"
    :background-color="'transparent'" :fixed="true" :show-border="false" @right-click="go('/BillingRecord')" />

  <!-- 余额区域 -->
  <div class="balance-section">
    <div class="balance-title">鲸油</div>
    <div class="balance-amount">{{ balanceData.balance }}</div>
    <div class="balance-detail">
      其中可用 {{ balanceData.availableBalance }} 鲸油，冻结中 {{ balanceData.frozenBalance }} 鲸油
    </div>

    <!-- 按钮组 -->
    <div class="button-group">
      <el-button class="action-btn" @click="handleRechargeClick">充值</el-button>
      <el-button class="action-btn" @click="handleWithDrawalClick">提现</el-button>
    </div>
  </div>

  <!-- 设置列表 -->
  <div class="settings-list">
    <div class="settings-title">常见设置</div>
    <div class="settings-item" @click="handleLimitClick">
      <span>提高限额</span>
      <div class="right-content">
        <span class="hint-text">上传身份信息</span>
        <el-icon>
          <ArrowRight />
        </el-icon>
      </div>
    </div>
    <div class="settings-item" @click="handleResetPasswordClick">
      <span>重置支付密码</span>
      <el-icon>
        <ArrowRight />
      </el-icon>
    </div>
    <div class="settings-item" @click="handleBankCardClick">
      <span>银行卡管理</span>
      <el-icon>
        <ArrowRight />
      </el-icon>
    </div>
  </div>

  <!-- 底部帮助文本 -->
  <div class="help-text">
    如有疑问联系鲸宝：<div class="help-link" @click="handleHelpClick">客服</div>
  </div>
</template>

<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { getBalance } from "@/api/wallet";
import { ref } from "vue";
import { showToast } from "vant";
import router from "@/router";

interface BalanceData {
  balance: number;
  availableBalance: number;
  frozenBalance: number;
}

const balanceData = ref<BalanceData>({
  balance: 0,
  availableBalance: 0,
  frozenBalance: 0
});

onMounted(() => {
  getBalanceData()
})

const getBalanceData = () => {
  getBalance().then(res => {
    if (res.code === 200) {
      balanceData.value = res.data
    } else {
      showToast(res.msg)
    }
  })
}

const go = (path: string) => {
  router.push(path)
}

const handleRechargeClick = () => {
  router.push('/Recharge')
}

const handleWithDrawalClick = () => {
  router.push('/WithDrawal')
}

const handleLimitClick = () => {
  // 处理提高限额点击
  go('/AuthSfz')
}

const handleResetPasswordClick = () => {
  // 处理重置支付密码点击
  go('/ResetPayPwd')
}

const handleBankCardClick = () => {
  // 处理银行卡管理点击
  go('/BankCard')
}
</script>

<style lang="scss" scoped>
.balance-section {
  padding: 90px 20px 20px;
  box-sizing: border-box;
  height: 250px;
  color: #fff;
  background: linear-gradient(46deg, #0B6DFF 0%, rgba(4, 16, 246, 0.5) 100%);

  .balance-title {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .balance-amount {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .balance-detail {
    font-size: 14px;
    margin-bottom: 20px;
    letter-spacing: 1px;
  }

  .button-group {
    display: flex;
    gap: 6px;

    .action-btn {
      padding: 4px 14px;
      font-size: 14px;
      font-weight: bold;
      color: #764701;
      border-radius: 16px;
      background-image: linear-gradient(45deg, #D3B17D 0%, #FFDEAA 100%);
      border: none;
    }
  }
}

.settings-list {
  background: #fff;
  border-radius: 8px;

  .settings-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
  }

  .settings-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #f4f4f4;

    .right-content {
      display: flex;
      align-items: center;
      gap: 4px;

      .hint-text {
        font-size: 14px;
        font-weight: normal;
        color: #999;
      }
    }

    &:active {
      background: #f5f5f5;
    }

    .el-icon {
      font-size: 15px;
      color: #999;
    }
  }
}

.help-text {
  margin-top: 20px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  .help-link {
    color: #409EFF;
  }
}
</style>
